import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';
import { VideoPlayerType } from '../../types';

@Component({
  standalone: false,
  selector: 'campus-about-section',
  templateUrl: './about-section.component.html',
  styleUrls: ['./about-section.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AboutSectionComponent {
  @HostBinding('class')
  defaultClasses = ['block'];

  @Input() anchor: string;
  @Input() title: string;
  @Input() videoId: string;
  @Input() player: VideoPlayerType = 'wistia';
  @Input() readMoreLink: string;
}
